import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
import AdSlot from '../components/AdSlot';
import { translations } from '../data/translations';
import { getGenerators } from '../data/generators';

export default function Home({ lang }) {
    const t = (key) => translations[lang][key] || key;
    const generators = getGenerators(lang);

    return (
        <>
            <Helmet>
                <title>{t('title')} - 20+ Free Developer Tools</title>
                <meta name="description" content={t('heroDesc')} />
                <link rel="canonical" href={`https://everytool.pro/${lang}`} />
            </Helmet>

            <AdSlot label={t('adPlaceholder')} />

            <div className="space-y-12">
                <div className="text-center space-y-6 py-12">
                    <h1 className="text-4xl md:text-7xl font-black text-slate-900 leading-tight">
                        {t('heroTitle')}<span className="text-blue-600">{t('heroSpan')}</span>
                    </h1>
                    <p className="text-lg text-slate-500 max-w-2xl mx-auto font-medium">{t('heroDesc')}</p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                    {generators.map(gen => (
                        <Link key={gen.id} to={`/${lang}/${gen.path}`} className="bg-white p-6 rounded-[2rem] border border-slate-200 hover:border-blue-400 transition-all cursor-pointer shadow-sm hover:shadow-xl group block">
                            <div className="w-12 h-12 bg-slate-50 text-blue-600 rounded-xl flex items-center justify-center mb-4 group-hover:bg-blue-600 group-hover:text-white transition-all">{gen.icon}</div>
                            <h3 className="text-lg font-black mb-1 flex items-center justify-between">{gen.name} <ChevronRight size={16} className="text-slate-300 group-hover:translate-x-1" /></h3>
                            <p className="text-slate-400 text-xs font-medium">{gen.description}</p>
                        </Link>
                    ))}
                </div>
            </div>
        </>
    );
}
